var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doubles-tab"},[(_vm.tabs.length)?_c('Subpanel',{staticClass:"doubles-tab__subpanel",attrs:{"name":_vm.tabs.length,"tabs":_vm.tabs,"module":"doubles"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }